import { render, staticRenderFns } from "./expenditure.vue?vue&type=template&id=e267d89e&scoped=true"
import script from "./expenditure.vue?vue&type=script&lang=js"
export * from "./expenditure.vue?vue&type=script&lang=js"
import style0 from "./expenditure.vue?vue&type=style&index=0&id=e267d89e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e267d89e",
  null
  
)

export default component.exports